<script>
	import { getContext } from "svelte";
	import { slide } from "svelte/transition";

	import { navigate } from "svelte-navigator";

	import model from "../../../stores/modelStore";
	import registrationList from "../../../stores/registrationListStore";

	import PrimaryButton from "../../../components/buttons/PrimaryButton.svelte";

	// props
	export let landingPage = null;
	export let disabled = false;

	const getReturnedRegistrationList = async () => {
		if (landingPage) return;

		if (token && key) {
			let resp = await fetch(`/api/return-registrations?token=${token}&key=${key}`);
			if (resp.ok) {
				$registrationList = await resp.json();
				console.log("registrationList", registrationList);
			}
		}
	};

	const navigateToRegistration = async (e, index) => {
		e.preventDefault();

		let options = {
			method: "GET",
			headers: {
				"Content-type": "application/json"
			}
		};

		var url = `/api/return-registration?token=${$registrationList[index].token}&key=${$registrationList[index].sessionKey}`;
		let response = await fetch(`${url}`, options);
		let registration = await response.json();

		let parent = { ...$model };

		$model = registration;
		$model.parentRegistrationNumber = $registrationList[index].parentRegistrationNumber;

		console.log("model", $model);

		navigate(`/SettlementRegistration/PersonalDetails`);
	};

	let tokens = getContext("_TOKENS_");
	console.log("tokens", tokens);
</script>

{#if tokens.token && tokens.key}
	{#await getReturnedRegistrationList() then}
		{#if $registrationList.length > 0}
			<div transition:slide|local>
				<table class="registrationList">
					<thead>
						<tr>
							<th>Registration Number</th>
							<th>Claimant Name</th>
							<th>Settlement Registration</th>
						</tr>
					</thead>
					<tbody>
						{#each $registrationList as registration, i}
							<tr>
								<td>{registration.registrationNumber}</td>
								<td>{registration.claimantName || registration.contactName} </td>
								{#if registration.complete}
									{#if registration.settlementRegistrationType === "Contact Shine"}
										<td>You must contact Shine Lawyers to register</td>
									{:else}
										<td>Registration Complete</td>
									{/if}
								{:else}
									<td>
										<PrimaryButton small {disabled} on:click={(e) => navigateToRegistration(e, i)}>
											Click here to finish your Registration
										</PrimaryButton>
									</td>
								{/if}
							</tr>
						{/each}
					</tbody>
				</table>
			</div>
		{/if}
	{/await}
{/if}

<style>
	.registrationList {
		margin-top: 20px;
		margin-left: auto;
		margin-right: auto;
	}

	.registrationList td,
	.registrationList th {
		padding: 10px;
	}
</style>
